import { ComponentProps } from 'react';
import { twMerge } from 'tailwind-merge';

export type DividerProps = ComponentProps<'hr'>;

export function Divider({ className, ...props }: DividerProps) {
  return (
    <hr className={twMerge('border border-gray-200', className)} {...props} />
  );
}
